var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-vr.ts
import { customElement } from "lit/decorators.js";
import { ChemistryLiteElement } from "../../chemistry-lite-element.js";
var XVerticalRule = class extends ChemistryLiteElement {
  constructor() {
    super(...arguments);
    this.styles = () => [
      { flex: "none", display: "block", height: "100%", width: "1px", background: this.colors.neutral.shade(300) }
    ];
  }
};
XVerticalRule = __decorateClass([
  customElement("x-vr")
], XVerticalRule);
export {
  XVerticalRule
};
